
import * as angular from "angular";

interface ICountToData {
    element: HTMLElement;
    timeoutPromise?: angular.IPromise<any>;
    refreshInterval?: number;
    duration?: number;
    step?: number;
    steps?: number;
    countFrom?: number;
    countTo?: number;
    value?: number;
    increment?: number;
    num?: number;

    filter?: string;
    filterParam?: any;
}

export class CountToDirective implements angular.IDirective {

    restrict = "A";

    link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;

    constructor(
        private $timeout: angular.ITimeoutService,
        private $filter: angular.IFilterService) {

        CountToDirective.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, attrs: ng.IAttributes) => {

            var countToData: ICountToData = {
                element: $element[0]
            };

            this.setFilters(countToData, attrs);

            attrs.$observe("countTo", (val) => {
                if (val) {
                    this.start(countToData, attrs);
                }
                else {
                    this.setContent(countToData, 0);
                }
            });
        }
    }

    private start(countToData: ICountToData, attrs: ng.IAttributes) {
        if (countToData && countToData.timeoutPromise) {
            this.$timeout.cancel(countToData.timeoutPromise);
        }

        this.calculate(countToData, attrs);
        this.tick(countToData);
    }

    private setFilters(countToData: ICountToData, attrs: ng.IAttributes) {

        countToData.filter = attrs["filter"] || "number";
        countToData.filterParam = attrs["filterParam"] || 0;
    }

    private calculate(countToData: ICountToData, attrs: ng.IAttributes) {
        countToData.refreshInterval = 30;
        countToData.step = 0;
        countToData.timeoutPromise = null;

        countToData.value = countToData.countTo || 0;
        countToData.countFrom = countToData.value;
        let countToString: string = attrs["countTo"] || "0";

        // If we have any commas (from number formatting) remove them
        if (countToData && countToString.indexOf(",")) {
            countToString = countToString.split(",").join("");
        }

        countToData.countTo = parseFloat(countToString);

        countToData.duration = (parseFloat(attrs["duration"]) * 1000) || 300; // default half second

        countToData.steps = Math.ceil(countToData.duration / countToData.refreshInterval);
        countToData.increment = ((countToData.countTo - countToData.value) / countToData.steps);
        countToData.num = countToData.value;
    }

    private tick(countToData: ICountToData) {
        countToData.timeoutPromise = this.$timeout(() => {
            var newData = this.easeOutCubic(countToData.step + 1, countToData.countFrom, countToData.countTo - countToData.countFrom, countToData.steps);
            countToData.num = newData;

            countToData.step++;

            if (countToData.step >= countToData.steps) {
                this.$timeout.cancel(countToData.timeoutPromise);
                countToData.num = countToData.countTo;

                this.setContent(countToData, countToData.countTo);
            }
            else {
                this.setContent(countToData, countToData.num);

                this.tick(countToData);
            }

        }, countToData.refreshInterval);
    }

    private setContent(countToData: ICountToData, value: number) {
        countToData.element.textContent = this.$filter<any>(countToData.filter)(value, countToData.filterParam);
    }

    private easeOutCubic(t_currentTime: number, b_startValue: number, c_endValue: number, d_duration: number) {
        // Source: https://joshondesign.com/2013/03/01/improvedEasingEquations
        // Source: https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
        return c_endValue * ((t_currentTime = t_currentTime / d_duration - 1) * t_currentTime * t_currentTime + 1) + b_startValue;
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($timeout: angular.ITimeoutService, $filter: angular.IFilterService) => new CountToDirective($timeout, $filter);

        directive.$inject = ["$timeout", "$filter"];

        return directive;
    }
}
